<template>
    <div id="modules_wrapper">
        <v-dialog
            v-model="moduleDataDialog"
            transition="scale-transition"
            origin="center center"
            fullscreen>
            <v-card class="d-flex align-start">
                <div style="width: 100%">
                    <ModuleDetails
                        :module_id="this_moduleId"
                        @closeDetailDialog="closeDetailDialog" />
                </div>
            </v-card>
        </v-dialog>

        <!-- <v-navigation-drawer
            v-model="projectActivityDialog"
            app
            relative
            right
            temporary
            width="46%">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="primary--text text--darken-2 font-weight-bold" :style="`border-bottom: 1px solid ${'primary-darken-2'}`">Activity Log</v-card-title>
                <v-card-text class="pt-3">
                    <ProjectActivity
                        :projectID="projectForActivity"
                        :userID="userForctivity" />
                </v-card-text>
            </v-card>
        </v-navigation-drawer> -->

        <div class="pt-8 d-flex">
            <div class="sansation info--text d-inline mx-4"><h2>Module Dashboard</h2></div>
        </div>

        <div class="pt-0 pb-4 px-2" flat>
            <div class="d-flex d-block justify-space-between mb-4">
                <div class="d-inline" style="width: 40%">
                    <v-text-field 
                        v-model="search"
                        hint="Search for an existing module"
                        persistent-hint 
                        single-line 
                        color="primary darken-1" 
                        append-icon="mdi-magnify"
                        class="ml-2 mr-6">
                    </v-text-field>
                </div>
                <!-- <div class="d-flex d-inline mt-3 mb-7">
                    
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.status"
                            :items="project_statuses" 
                            label="Status" 
                            :hint="filteredProjects.length ? project_status_metadata.join(', ') : ''"
                            persistent-hint
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-1"
                            @change="filterProjects()">
                                <template v-slot:message="{ message }">
                                    <span v-html="message"></span>
                                </template>
                        </v-autocomplete>
                    </div>
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.module"
                            :items="services" 
                            label="Service(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-1"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.service_levels"
                            :items="service_levels" 
                            label="Service Level(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-1"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                </div> -->
            </div>

            <!-- <div class="d-flex justify-end" v-if="filtered_projects_cnt">
                {{ filtered_projects_cnt }} total results
            </div> -->
        </div>

        <!-- <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>               
                <v-expansion-panel-content> -->
                    <v-data-table
                        :headers="headers"
                        :items="all_modules"
                        :items-per-page="-1"
                        :search="search"
                        :loading="table_loading"
                        loading-text="Pulling modules ..."
                        item-key="module_id"
                        fixed-header
                        :height="'calc(100vh - 300px)'"
                        @click:row="openModuleDetails"
                    >

                        <template v-slot:no-data>
                            <div class="text-center pt-12">
                                <v-icon large>mdi-alert-circle</v-icon>
                                <p class="mt-2">No modules found matching your filters.</p>
                            </div>
                        </template>

                        <template v-slot:module_name="{ item }">
                            <div class="" v-html="item.module_name"></div>
                        </template>

                        <!-- :options.sync="options"
                        :expanded.sync="expanded"                        
                        show-expand
                        single-expand
                        @current-items="getFiltered"
                        @update:options="onUpdateOptions" -->

                        <!-- Custom Row Template -->
                        <!-- <template v-slot:item="{ item, expand, isExpanded }"> -->
                        <!-- <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="(item) in items" 
                                    :key="item.module_id" 
                                    @click.stop="openModuleDetails( item )"
                                    class="table-row"> -->

                                    <!-- <td class="text-start grow-1">{{ item.module_name }}</td> -->
                                    <!-- <td class="text-end">{{ item.is_active }}</td> -->
                            <!-- <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <tr style="padding:0 !important; margin:0 !important;">
                                        <td colspan="12" v-bind="attrs" v-on="on" style="padding:0 !important; margin:1em !important;">
                                            <v-progress-linear 
                                                :value="item.complete == 0 ? 1 : Math.ceil(item.complete)"
                                                :color="item.status_progress_color"
                                                class="pa-0 ma-0" 
                                                height="5">
                                            </v-progress-linear>
                                        </td>
                                    </tr>
                                </template>
                                <span style="font-size: 1em" class="font-weight-bold">Project is {{ item.complete }}% complete</span>
                            </v-tooltip> -->

                            <!-- <tr @click.stop="openModuleDetails( item )" 
                                :key="item.module_id"
                                class="table-row"> -->

                                <!-- <td class="text-start" style="border:1px solid red">{{ item.module_name }}</td>
                                <td class="text-end" style="border:1px solid blue">{{ item.is_active }}</td> -->
                                <!-- Expand Icon -->
                                <!-- <td class="text-start align-text-top">
                                    <UserData_Dashboard :user_data="item.client_info"/>
                                    <div @click.stop="expand(!isExpanded)" 
                                        class="mt-4 mb-1 primary--text text--darken-1 text-decoration-none"
                                        :class="isExpanded ? `font-weight-thin` : `font-weight-bold `">
                                        <v-badge
                                            v-if="item.quick_notes != null"
                                            dot
                                            left
                                            inline
                                            color="error">
                                        </v-badge>
                                        <span class="d-inline">View Notes</span>
                                        <v-icon color="primary">
                                            {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                        </v-icon>
                                    </div>
                                </td>
                                < !-- Other Columns -- >
                                <td class="text-start align-text-top">
                                    <div v-html="item.project_label"></div>
                                    <div class="d-block" v-if="item.multi_project">
                                        <v-chip 
                                            x-small
                                            label
                                            class="font-weight-bold"
                                            text-color="white" 
                                            color="warning darken-1">
                                            multi-service project
                                        </v-chip>
                                    </div>
                                </td>
                                <td class="text-start align-text-top">
                                    <div v-if="item.next_call_label" v-html="item.next_call_label"></div>
                                    <div v-if="item.remaining_call_label" v-html="item.remaining_call_label"></div>
                                    <div v-html="item.calls_data_label"></div>
                                </td>
                                <td class="text-start align-text-top">
                                    <div class="text-left">
                                        <div v-if="item.last_contacted_label" v-html="item.last_contacted_label"
                                            class="d-block mb-4">
                                        </div>
                                        <div @click.stop="openProjectActivity( item )" 
                                            class="d-block primary--text text--darken-1 font-weight-bold text-decoration-none">
                                            View Activity
                                            <v-icon 
                                                small
                                                color="primary">
                                                mdi-arrow-right
                                            </v-icon>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-end align-text-top">{{ item.status_label }}</td>
                                <td class="text-end align-text-top" v-if="item.ready_to_submit">
                                    {{ item.current_stage }}
                                    <span class="d-block">
                                        <v-chip 
                                            x-small
                                            label
                                            class="font-weight-bold"
                                            text-color="white" 
                                            color="error">
                                            ready to submit
                                        </v-chip>
                                    </span>
                                </td>
                                <td class="text-end align-text-top" v-else>{{ item.current_stage }}</td>
                                <td class="text-end align-text-top">
                                    <v-progress-circular 
                                        :value="item.complete == 0 ? 2 : Math.ceil(item.complete)"
                                        :class="item.status_color"
                                        :rotate="-90"
                                        class="pa-0 ma-0" 
                                        size="43" 
                                        width="4" >
                                        
                                        <div :style="item.complete == 100 ? 'font-size: .8rem' : 'font-size: .9rem'"
                                            :class="item.status_color + '--text text--darken-2 font-weight-bold'">
                                            {{ item.complete }}
                                        </div>
                                    </v-progress-circular>
                                </td>
                                <td class="text-end align-text-top">{{ item.date_saved_label }}</td>
                                <td class="text-end align-text-top">{{ item.date_initialized_label }}</td>
                                <td class="text-end align-text-top" v-html="item.close_date_label"></td>
                                <td class="text-end align-text-top">
                                    <v-icon :class="item.expedite ? 'success--text text--darken-2' : 'grey--text text--lighten-2'">
                                        {{ item.expedite ? 'mdi-checkbox-marked' : 'mdi-close-box' }}
                                    </v-icon>
                                </td>
                                <td class="text-end align-text-top caption">{{ item.project_id }}</td>
                                <td class="text-end align-text-top"></td> -->
                            <!-- </tr>
                            </tbody>
                        </template> -->
                        
                        <!-- Expanded Row Template -->
                        <!-- <template v-slot:expanded-item="{ item }">
                            <tr>
                                <td colspan="14">
                                    <v-textarea
                                        v-model="item.quick_notes"
                                        label="Quick Notes"
                                        outlined
                                        background="#fff"
                                        rows="4">
                                    </v-textarea>
                                    <div class="d-block d-flex justify-start">
                                        <v-btn 
                                            color="primary" 
                                            class="d-flex d-inline font-weight-bold ml-1 mt-n3 mb-1"
                                            outlined
                                            x-small
                                            @click="saveQuickNotes(item)">
                                            save note
                                        </v-btn>
                                        <v-btn
                                            v-show="quick_note_saved_res"
                                            class="ml-2 mt-n3 d-inline white--text font-weight-bold"
                                            :class="quick_note_saved_res ? '' : 'fade-out-btn'"
                                            color="accent"
                                            elevation="0"
                                            x-small
                                            text>
                                            Saved
                                        </v-btn>
                                    </div>
                                </td>
                            </tr>
                        </template> -->
                    </v-data-table>
                    
                <!-- </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels> -->
    </div>
</template>


<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment'

    import { mdiAccount, mdiPencil, mdiDelete, mdiMagnify } from '@mdi/js'

    import ModuleDetails from './ModuleDetails'

    export default {

        components: {
            ModuleDetails
        },

        data: () => ({
            expanded: [],
            name: 'Modules',
            icons: {
                accountIcon: mdiAccount,
                pencilIcon: mdiPencil,
                deleteIcon: mdiDelete,
                magnifyIcon: mdiMagnify,
            },
            dialog: false,
            moduleDataDialog: false,
            errorMsg: '',
            searchInput: '',
            table_loading: false,
            search: '',
            filterby: {
                module: [],
                status: ['open', 'review', 'processing'],
                service_levels: [],
                search: ''
            },
            options: {
                sortBy: ['close_date'],
                sortDesc: [true],
                // Initialize other options as needed
                itemsPerPage: -1,
                multiSort: true
            },
            headers: [
                { text: 'Module Name',  value: 'module_name',   align: 'start', sortable: true, class: 'tbl_headers' },
                { text: 'Active',       value: 'is_active',     align: 'end',   sortable: true },
            ],
            users_sortorder: ['owner', 'secondary', 'partner'],
            panel: [0],
            all_modules: [],
            project_status_metadata: [],
            filteredProjects: [],
            filteredProjectsPerStatus: [],
            filtered_projects_cnt: 0,
            admin_matches: [],
            menu1: false,
            this_moduleId: '',
            debounceTimeout: null,
            quick_note_saved_res: false,
            projectActivityDialog: false,
            projectForActivity: '',
            userForctivity: '',
            selectedRow: {},
        }),
        
        
        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        mounted () {
            this.table_loading = true
            this.getModules()
        },

        methods: {
            debouncedSearch() {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(() => {
                    this.getModules()
                }, 200);
            },

            openModuleDetails: async function ( item ) {
                // console.log(item)
                this.selectedRow = { ...item }

                this.this_moduleId = this.selectedRow.module_id
                this.moduleDataDialog = true
            },

            closeDetailDialog: function () {
                this.moduleDataDialog = false
                this.this_moduleId = ''
                this.getModules()
            },

            getModules: async function () {
                // this.modules = []
                const all_modules = await axios.get(`${appUrls.api}/api/admin/submodule/true/all_modules`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                
                if ( all_modules.data.outcome ) {
                    this.all_modules = all_modules.data.modules
                    this.table_loading = false
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .v-dialog__content {
        width: 98vw !important;
    }
    #modules_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 3rem 0 0 0;
        display: flex;
        flex-direction: column;
        height: 100vh; /* ensure wrapper fills viewport */
    }
    .header_bg_color {
        background-color: var(--v-primary-darken3)
    }
    tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
 >>> tbody tr {
        cursor: pointer !important;
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }
    .v-data-table { 
        overflow-x: auto;
    }
    .title {
        padding: .5em;
    }
    #new_btn {
        width: 100%;
        text-align: right;
    }
    .listing_row {
        text-align: left;
    }
    tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, .05);
    }
    .tbl_headers {
        padding: 0 !important;
    }
    .dialog_title_bkg {
        background-color: #2196f3; /* #17a2b8 */
        color: #fff
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .v-expansion-panel-header.v-expansion-panel-header {
        padding: 1em !important;
        margin: 0 !important;
    }
    .v-expansion-panel-header.v-expansion-panel-header--active,
    .v-expansion-panel-header.v-expansion-panel-header:hover {
        background: #eef7f8;
        padding: 1em !important;
        margin: 0 !important;
        /* background-color: rgba(189, 235, 249, 0.25); */
    }
 >>> .v-expansion-panel-content__wrap {
        padding: .5em 0 !important; 
        /* margin: 0 !important;     */
    }
 >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        /* margin: 0 !important; */
        /* border: 1px solid green !important; */
    }
    .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        /* border: 1px solid blue !important; */
    }
 >>> .v-data-table__expanded {
        background-color: #fff !important;
        padding: .8em 1em .8em 1em !important;
        height: 90px !important;
    }
    .text-underline {
        text-decoration: underline;
    }
    .fade-out-btn {
        transition: opacity 0.5s ease-out; /* Smooth fade-out transition */
    }
    .fade-out-btn[v-cloak] {
        display: none; /* Prevent flash before Vue mounts */
    }
    .fade-out-btn:not([v-show]) {
        opacity: 0; /* Fade out when hidden */
    }
    .align-text-top {
       vertical-align: top;
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
    }

    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }

    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/Modules.vue